export default callback => (dispatch, getState) => {

  const { token, entry, wtRegion, isoCode, clientEmail } = getState();

  fetch(`${process.env.REACT_APP_API_URL}/text/compliance/all/?isocode=${isoCode}&wtRegion=${wtRegion}&entityCCY=${entry.original.entityCCY}&clientEmail=${clientEmail}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token &&
        `Token ${token}`,
    },
  })
    .then(d => d.json())
    .then(text => {
      dispatch({ type: 'SAVE_COMPLIANCE_TEXT', text })
      callback && callback()
    })
    .catch(error => {
      console.error(error);
    });
};



// WEBPACK FOOTER //
// ./src/actions/query-api/compliance.js